import { render } from "./ChartFactIncome.vue?vue&type=template&id=93308b40&scoped=true"
import script from "./ChartFactIncome.vue?vue&type=script&lang=js"
export * from "./ChartFactIncome.vue?vue&type=script&lang=js"

import "./ChartFactIncome.vue?vue&type=style&index=0&id=93308b40&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93308b40"]])

export default __exports__